import { Lock } from 'lucide-react';

import { links } from '@/lib/constants';

export const DataPrivacyStatement = () => {
  return (
    <div className="text-charcoal-500 mt-4 flex items-start gap-2 text-sm">
      <Lock className="size-5 shrink-0" aria-hidden="true" />
      <p>
        All information you share is secure and confidential. See our{' '}
        <a
          href={links.conduit_hipaa_notice_url}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Read our HIPAA statement (opens in a new tab)"
        >
          HIPAA statement
        </a>
        .
      </p>
    </div>
  );
};
